@if (buttonOptions.internalLink || buttonOptions.externalLink) {
  @if (buttonOptions.externalLink) {
    <a [href]="buttonOptions.externalLink" class="w-100">
      <!-- The wrapping link is the tab stop -->
      <button
        [attr.tabindex]="buttonOptions.innerTabIndex ?? -1"
        [class]="buttonOptions.class + ' button'"
        [class.primary]="buttonOptions.type === 'primary'"
        [class.secondary]="buttonOptions.type === 'secondary'"
        [class.tertiary]="buttonOptions.type === 'tertiary'"
        [class.facet]="buttonOptions.type === 'facet'"
        [class.graph-swap]="buttonOptions.type === 'graph-swap'"
        [class.tiny-primary]="buttonOptions.type === 'tiny-primary'"
        [class.tiny-use-case]="buttonOptions.type === 'tiny-use-case'"
        [class.tag]="buttonOptions.type === 'tag'"
        [class.no-min-width]="buttonOptions.unsetWidth"
        [disabled]="buttonOptions.disabled"
        >
        @if (buttonOptions.iconPosition == 'left') {
          <div
            class="icon-left"
                    [ngClass]="{
                        'icon-size-small': buttonOptions.iconSize === 'small',
                        'icon-size-medium': buttonOptions.iconSize === 'medium',
                        'icon-size-large': buttonOptions.iconSize === 'large'
                    }"
            >
            <i-feather
              class="button-icon"
              [name]="buttonOptions?.iconName"
                        [ngClass]="{
                            'icon-size-small': buttonOptions.iconSize === 'small',
                            'icon-size-medium': buttonOptions.iconSize === 'medium',
                            'icon-size-large': buttonOptions.iconSize === 'large',
                            'stroke-width-small': buttonOptions.iconStrokeWidth === 'small',
                            'stroke-width-medium': buttonOptions.iconStrokeWidth === 'medium',
                            'stroke-width-large': buttonOptions.iconStrokeWidth === 'large'
                        }"
            ></i-feather>
          </div>
        }
        <div class="button-text">{{ buttonOptions.text }}</div>
        @if (buttonOptions.iconPosition == 'right') {
          <div
            class="icon-right"
                    [ngClass]="{
                        'icon-size-small': buttonOptions.iconSize === 'small',
                        'icon-size-medium': buttonOptions.iconSize === 'medium',
                        'icon-size-large': buttonOptions.iconSize === 'large'
                    }"
            >
            <i-feather
              class="button-icon"
              [name]="buttonOptions?.iconName"
                        [ngClass]="{
                            'icon-size-small': buttonOptions.iconSize === 'small',
                            'icon-size-medium': buttonOptions.iconSize === 'medium',
                            'icon-size-large': buttonOptions.iconSize === 'large',
                            'stroke-width-small': buttonOptions.iconStrokeWidth === 'small',
                            'stroke-width-medium': buttonOptions.iconStrokeWidth === 'medium',
                            'stroke-width-large': buttonOptions.iconStrokeWidth === 'large'
                        }"
            ></i-feather>
          </div>
        }
      </button>
    </a>
  } @else {
    <a [routerLink]="buttonOptions.internalLink" class="w-100">
      <ng-container *ngTemplateOutlet="plainButton"></ng-container>
    </a>
  }
} @else {
  <button
    [attr.tabindex]="buttonOptions.innerTabIndex ?? null"
    [class]="buttonOptions.class + ' button'"
    [class.primary]="buttonOptions.type === 'primary'"
    [class.secondary]="buttonOptions.type === 'secondary'"
    [class.tertiary]="buttonOptions.type === 'tertiary'"
    [class.facet]="buttonOptions.type === 'facet'"
    [class.graph-swap]="buttonOptions.type === 'graph-swap'"
    [class.tiny-primary]="buttonOptions.type === 'tiny-primary'"
    [class.tiny-use-case]="buttonOptions.type === 'tiny-use-case'"
    [class.tag]="buttonOptions.type === 'tag'"
    [class.no-min-width]="buttonOptions.unsetWidth"
    [disabled]="buttonOptions.disabled"
    >
    @if (buttonOptions.iconPosition == 'left') {
      <div
        class="icon-left"
                [ngClass]="{
                    'icon-size-small': buttonOptions.iconSize === 'small',
                    'icon-size-medium': buttonOptions.iconSize === 'medium',
                    'icon-size-large': buttonOptions.iconSize === 'large'
                }"
        >
        <i-feather
          class="button-icon"
          [name]="buttonOptions?.iconName"
                    [ngClass]="{
                        'icon-size-small': buttonOptions.iconSize === 'small',
                        'icon-size-medium': buttonOptions.iconSize === 'medium',
                        'icon-size-large': buttonOptions.iconSize === 'large',
                        'stroke-width-small': buttonOptions.iconStrokeWidth === 'small',
                        'stroke-width-medium': buttonOptions.iconStrokeWidth === 'medium',
                        'stroke-width-large': buttonOptions.iconStrokeWidth === 'large'
                    }"
        ></i-feather>
      </div>
    }
    <div class="button-text">{{ buttonOptions.text }}</div>
    @if (buttonOptions.iconPosition == 'right') {
      <div
        class="icon-right"
                [ngClass]="{
                    'icon-size-small': buttonOptions.iconSize === 'small',
                    'icon-size-medium': buttonOptions.iconSize === 'medium',
                    'icon-size-large': buttonOptions.iconSize === 'large'
                }"
        >
        <i-feather
          class="button-icon"
          [name]="buttonOptions?.iconName"
                    [ngClass]="{
                        'icon-size-small': buttonOptions.iconSize === 'small',
                        'icon-size-medium': buttonOptions.iconSize === 'medium',
                        'icon-size-large': buttonOptions.iconSize === 'large',
                        'stroke-width-small': buttonOptions.iconStrokeWidth === 'small',
                        'stroke-width-medium': buttonOptions.iconStrokeWidth === 'medium',
                        'stroke-width-large': buttonOptions.iconStrokeWidth === 'large'
                    }"
        ></i-feather>
      </div>
    }
  </button>
}

<!-- Only rendered inside the internalLink <a>, which is the tab stop -->
<ng-template #plainButton>
  <button
    [attr.tabindex]="buttonOptions.innerTabIndex ?? -1"
    [class]="buttonOptions.class + ' button'"
    [class.primary]="buttonOptions.type === 'primary'"
    [class.secondary]="buttonOptions.type === 'secondary'"
    [class.tertiary]="buttonOptions.type === 'tertiary'"
    [class.facet]="buttonOptions.type === 'facet'"
    [class.graph-swap]="buttonOptions.type === 'graph-swap'"
    [class.tiny-primary]="buttonOptions.type === 'tiny-primary'"
    [class.tiny-use-case]="buttonOptions.type === 'tiny-use-case'"
    [class.tag]="buttonOptions.type === 'tag'"
    [class.no-min-width]="buttonOptions.unsetWidth"
    [disabled]="buttonOptions.disabled"
    >
    @if (buttonOptions.iconPosition == 'left') {
      <div
        class="icon-left"
                [ngClass]="{
                    'icon-size-small': buttonOptions.iconSize === 'small',
                    'icon-size-medium': buttonOptions.iconSize === 'medium',
                    'icon-size-large': buttonOptions.iconSize === 'large'
                }"
        >
        <i-feather
          class="button-icon"
          [name]="buttonOptions?.iconName"
                    [ngClass]="{
                        'icon-size-small': buttonOptions.iconSize === 'small',
                        'icon-size-medium': buttonOptions.iconSize === 'medium',
                        'icon-size-large': buttonOptions.iconSize === 'large',
                        'stroke-width-small': buttonOptions.iconStrokeWidth === 'small',
                        'stroke-width-medium': buttonOptions.iconStrokeWidth === 'medium',
                        'stroke-width-large': buttonOptions.iconStrokeWidth === 'large'
                    }"
        ></i-feather>
      </div>
    }
    <div class="button-text">{{ buttonOptions.text }}</div>
    @if (buttonOptions.iconPosition == 'right') {
      <div
        class="icon-right"
                [ngClass]="{
                    'icon-size-small': buttonOptions.iconSize === 'small',
                    'icon-size-medium': buttonOptions.iconSize === 'medium',
                    'icon-size-large': buttonOptions.iconSize === 'large'
                }"
        >
        <i-feather
          class="button-icon"
          [name]="buttonOptions?.iconName"
                    [ngClass]="{
                        'icon-size-small': buttonOptions.iconSize === 'small',
                        'icon-size-medium': buttonOptions.iconSize === 'medium',
                        'icon-size-large': buttonOptions.iconSize === 'large',
                        'stroke-width-small': buttonOptions.iconStrokeWidth === 'small',
                        'stroke-width-medium': buttonOptions.iconStrokeWidth === 'medium',
                        'stroke-width-large': buttonOptions.iconStrokeWidth === 'large'
                    }"
        ></i-feather>
      </div>
    }
  </button>
</ng-template>
